"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../get-full/index");
function convert(date, type, format) {
    if (format === undefined || format === null || !format) {
        format = 'y/m/d';
    }
    var _a = index_1.default(date, type), year = _a.year, month = _a.month, day = _a.day, hour = _a.hour, minute = _a.minute, second = _a.second, millisecond = _a.millisecond, monthName = _a.monthName, dayName = _a.dayName;
    var YEAR = String(year);
    var MONTH = month > 9 ? String(month) : "0" + String(month);
    var DAY = day > 9 ? String(day) : "0" + String(day);
    var HOUR = hour > 9 ? String(hour) : "0" + String(hour);
    var MINUTE = minute > 9 ? String(minute) : "0" + String(minute);
    var SECOND = second > 9 ? String(second) : "0" + String(second);
    var Milisecond = String(millisecond);
    var MILISECOND = Milisecond.length === 3 ? Milisecond :
        Milisecond.length === 2 ? "0" + Milisecond :
            Milisecond.length === 1 ? "00" + Milisecond : "000";
    var result;
    result = format.replace(/min/, MINUTE);
    result = result.replace(/sec/, SECOND);
    result = result.replace(/msec/, MILISECOND);
    result = result.replace(/[yY]/, YEAR);
    result = result.replace(/[m]/, MONTH);
    result = result.replace(/[M]/, monthName);
    result = result.replace(/[d]/, DAY);
    result = result.replace(/[D]/, dayName);
    result = result.replace(/[hH]/, HOUR);
    return result;
}
exports.default = convert;
